import { z } from 'zod';
import { EvaluationCheckSchema } from './evaluationDescription.js';
/** A task version's expected checks: the partial-credit denominator. */
export const EvaluationCheckNamesSchema = z
    .array(z.string().min(1))
    .min(1)
    .refine((names) => new Set(names).size === names.length, 'Check names must be unique');
export const EvaluationCheckResultSchema = EvaluationCheckSchema.pick({
    name: true,
    passed: true,
}).extend({
    /** Absent when the trial reported the check; `notRun` when a declared check was never reported. */
    outcome: z.enum(['notRun']).optional(),
});
export const EvaluationCheckPassCountSchema = z.object({
    name: z.string(),
    passedTrialCount: z.number().int().nonnegative(),
    trialCount: z.number().int().positive(),
});
/** Partial credit across a batch's passed and failed trials. */
export const EvaluationBatchScoreSchema = z.object({
    checkPassCounts: z.array(EvaluationCheckPassCountSchema),
    checkScoreTotal: z.number().nonnegative(),
    meanCheckScore: z.number().min(0).max(1).nullable(),
    scoredTrialCount: z.number().int().nonnegative(),
});
/** Each scored task contributes its mean check score with equal weight. */
export const EvaluationSuiteScoreSchema = z.object({
    meanCheckScore: z.number().min(0).max(1).nullable(),
    scoredTaskCount: z.number().int().nonnegative(),
    taskCheckScoreTotal: z.number().nonnegative(),
});
//# sourceMappingURL=evaluationScore.js.map